import Voice from './Voice'

export default Voice
